import { render, staticRenderFns } from "./StatesPage.vue?vue&type=template&id=4a27b64d&"
import script from "./StatesPage.vue?vue&type=script&lang=js&"
export * from "./StatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports